/**
 * @module components\ghModelView\propView\templates\dateInpute
 */
import Vue from "vue";
import Component from "vue-class-component";
import Base from "./../../base";

@Component
export default class DateInpute extends Base {
  private get Value() {
    try {
      let value = eval("this.model." + this.prop.value);
      if (value) {
        let d = new Date(value);
        d.setHours(d.getHours() + 8);
        return d.toISOString().substr(0, 10);
      }
    } catch (error) {
      return null;
    }
  }
  created() {
    try {
      let value = eval("this.model." + this.prop.value);
      if (!value) {
        this.$set(this.model, this.prop.value, null);
      }
    } catch (error) {
      this.$set(this.model, this.prop.value, null);
    }
  }
}
